import Vue from 'vue'
import Vuex from 'vuex'
import allAuth from './all/auth'
import employee from './manager/employee'
import vendor from './manager/vendor'
import employeeVendor from './employee/vendor'
import adminCompany from './admin/company'
import adminEmployee from './admin/employee'
import adminRequest from './admin/request'
import managerFolder from './manager/folder'
import adminFolder from './admin/folder'
import employeeFolder from './employee/folder'
import managerDashboard from './manager/dashboard'
import employeeDashboard from './employee/dashboard'
import dashboardEmployee from './admin/dashboardEmployee'
import adminDashboard from './admin/adminDashboard'
import employeeMyPage from './employee/mypage'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    allAuth,
    employee,
    vendor,
    employeeVendor,
    adminCompany,
    adminEmployee,
    adminRequest,
    managerFolder,
    adminFolder,
    employeeFolder,
    managerDashboard,
    employeeDashboard,
    dashboardEmployee,
    adminDashboard,
    employeeMyPage
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js